import { createAction, handleActions } from 'redux-actions';
import { call, put, takeLatest } from 'redux-saga/effects';
import { requestTwoDeptList } from 'modules/fetch/api';

const ACTIVE_TWODEPT_GET = 'twoDept/ACTIVE_TWODEPT_GET';
const ACTIVE_TWODEPT_RESULT = 'twoDept/ACTIVE_TWODEPT_RESULT';
const ACTIVE_TWODEPT_RESET = 'twoDept/ACTIVE_TWODEPT_RESET';

export const twoDeptList = createAction(ACTIVE_TWODEPT_GET);
export const twoDeptReset = createAction(ACTIVE_TWODEPT_RESET);

const initialize = {
  twoDeptIndex: [],
};

export function* getTwoDeptList(action) {
  try {
    const result = yield call(requestTwoDeptList, action.payload);
    yield put({ type: ACTIVE_TWODEPT_RESULT, payload: result.data });
  } catch (err) {
    console.log(`consoleMessage:::${err.message}`);
  }
}

export function* twoDeptSaga() {
  yield takeLatest(ACTIVE_TWODEPT_GET, getTwoDeptList);
}

const twoDept = handleActions(
  {
    [ACTIVE_TWODEPT_RESULT]: (state, { payload: twoDeptIndex }) => {
      /* console.log('consoleMessage::::::::' + JSON.stringify(sentenceList)); */
      return { ...state, twoDeptIndex };
    },
    [ACTIVE_TWODEPT_RESET]: state => ({ ...state, twoDeptIndex: [] }),
  },
  initialize
);


export default twoDept;
